var store = {
    get: function (keyName, location) {
        var storage = location === 'local' ? localStorage : sessionStorage;
        var storeValue = storage.getItem(keyName);
        if (storeValue === 'true' || storeValue === 'false') {
            return Boolean(JSON.parse(storeValue));
        }
        /**
         * The following code checks if the parsed data is an object and return it back.
         * If the data is a string it will throw an error and the error will br catched in the
         * catch block and will return unparsed value.
         */
        try {
            return JSON.parse(storeValue);
        }
        catch (e) {
            return storeValue;
        }
    },
    set: function (keyName, value, location) {
        var storage = location === 'local' ? localStorage : sessionStorage;
        var stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        storage.setItem(keyName, stringValue);
    },
    remove: function (keyName, location) {
        var storage = location === 'local' ? localStorage : sessionStorage;
        storage.removeItem(keyName);
    }
};
export default store;
